/* ───────────────────────────────────────────────────────────────────────────
   LOAD MORE, NOT PAGE 2.

   The theme already owns a partial-render pipeline: the collection section
   answers to ?section_id=<id>, and the filter code swaps [data-js-partial]
   with what comes back. This reuses that endpoint and changes one thing: the
   new products are APPENDED to the grid instead of replacing it.

   THREE THINGS THIS FILE HAS TO SURVIVE.

   1. A filter change wipes the block. The theme sets partial.innerHTML, so
      every node inside it, including the button, is a new object and any
      listener bound to the old one is gone. So the click is delegated from
      document and the state is read off the DOM on every call, never cached.

   2. Appended cards start invisible. .animation--grid-item is opacity 0 until
      .animation--grid-item-revealed is added; the theme does that in
      animateGrid, which this cannot reach. So the class is added here, on the
      frame after insert, which is also what makes the fade read as a fade.

   3. Images are lazySizes, not native lazy. It watches the DOM for new
      .lazyload nodes, so appended images load themselves. Nothing to do.

   AUTO is the number of batches that load themselves before a click is asked
   for. It is deliberately not Infinity: an endless grid has no bottom, and
   the footer is where the size guide, the returns policy and the newsletter
   live. Two batches is long enough to feel like a scroll.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  var AUTO = 2;

  /* Two sections wear this control: the collection grid and the search
     results, and they do not share a grid class (.collection__grid vs
     .results_grid). Both selectors live here rather than the behaviour being
     copied into a second file, because a store where search still paginates
     and collections do not is the inconsistency this was fixing. */
  var GRIDS = '.collection__main .collection__grid, .collection__main .results_grid';
  var ITEMS = '.collection__grid > .grid__item, .results_grid > .grid__item';
  var SECTIONS = '[data-section-type="collection"], [data-section-type="search"]';

  var busy = false;
  var autoUsed = 0;
  var io = null;

  function block() {
    return document.querySelector('[data-bml]');
  }

  function grid() {
    return document.querySelector(GRIDS);
  }

  function sectionId() {
    var s = document.querySelector(SECTIONS);
    return s ? s.getAttribute('data-section-id') : null;
  }

  /* The href a human should get. A section-rendered response builds its own
     pagination URLs out of the request we sent, so section_id rides along in
     them; left in place, the no-JS fallback would serve a bare fragment. */
  function clean(href) {
    if (!href) return '';
    try {
      var u = new URL(href, window.location.origin);
      u.searchParams.delete('section_id');
      return u.pathname + (u.search || '');
    } catch (e) {
      return href;
    }
  }

  function load(auto) {
    var b = block();
    if (!b || busy) return;

    var next = b.getAttribute('data-next');
    var g = grid();
    var sid = sectionId();
    if (!next || !g || !sid) return;

    var url;
    try {
      url = new URL(next, window.location.origin);
    } catch (e) {
      return;
    }
    url.searchParams.set('section_id', sid);

    busy = true;
    b.setAttribute('data-bml-busy', '');
    if (auto) autoUsed += 1;
    if (io) io.disconnect();

    fetch(url.toString(), { credentials: 'include' })
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.text();
      })
      .then(function (html) {
        var doc = new window.DOMParser().parseFromString(html, 'text/html');

        var added = [];
        var items = doc.querySelectorAll(ITEMS);
        for (var i = 0; i < items.length; i++) {
          var node = document.importNode(items[i], true);
          g.appendChild(node);
          added.push(node);
        }

        window.requestAnimationFrame(function () {
          for (var j = 0; j < added.length; j++) {
            added[j].classList.add('animation--grid-item-revealed');
          }
        });

        /* The count, the bar and the next href all come from the server that
           just rendered the page, which is the only thing that knows the
           total for the filters currently applied. */
        var fresh = doc.querySelector('[data-bml]');
        if (fresh) {
          /* The bar has to travel, or it is just a number in a second place.
             Replacing the markup would hand the browser a node that was born
             at the new width, and a transition needs two values, so the old
             width is carried across the swap and released on the next frame. */
          var was = b.querySelector('.bml__bar');
          var from = was ? was.style.width : '0%';

          b.innerHTML = fresh.innerHTML;
          b.setAttribute('data-next', clean(fresh.getAttribute('data-next')));

          var a = b.querySelector('[data-bml-more]');
          if (a) a.setAttribute('href', b.getAttribute('data-next'));

          var bar = b.querySelector('.bml__bar');
          if (bar) {
            var to = bar.style.width;
            bar.style.width = from;
            window.requestAnimationFrame(function () {
              bar.style.width = to;
            });
          }
        } else {
          b.setAttribute('data-next', '');
        }
      })
      .catch(function () {
        /* A failed batch must not eat the control. The button stays, pointing
           at a real URL, so the next click either works or navigates. */
        if (auto) autoUsed = AUTO;
      })
      .then(function () {
        busy = false;
        var cur = block();
        if (cur) cur.removeAttribute('data-bml-busy');
        watch();
      });
  }

  /* Arm the auto-load, but only while batches are left in the budget. */
  function watch() {
    if (io) {
      io.disconnect();
      io = null;
    }
    if (autoUsed >= AUTO) return;
    if (!('IntersectionObserver' in window)) return;

    var b = block();
    if (!b || !b.getAttribute('data-next')) return;

    io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            load(true);
            return;
          }
        }
      },
      { rootMargin: '700px 0px' }
    );
    io.observe(b);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('[data-bml-more]');
    if (!a) return;
    e.preventDefault();
    load(false);
  });

  function start() {
    watch();
    var partial = document.querySelector('[data-js-partial]');
    if (partial && 'MutationObserver' in window) {
      /* childList without subtree on purpose: the theme replaces the whole
         partial on a filter change, which is the only thing that should
         reset the budget. Appending cards mutates .collection__grid, a level
         deeper, so this does not fire on our own work. */
      new window.MutationObserver(function () {
        autoUsed = 0;
        watch();
      }).observe(partial, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
